var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAvatarChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 24,
    viewBox: "0 0 21 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0819 13.3944C17.7924 14.1247 19.3294 15.1924 20.5959 16.5303C20.7879 16.7372 20.897 17.0045 20.9033 17.2834V21.8944C20.9033 22.2001 20.7787 22.4933 20.557 22.7095C20.3353 22.9256 20.0346 23.0471 19.721 23.0471H1.59245C1.2816 23.0471 0.983244 22.9278 0.761967 22.7149C0.540691 22.502 0.414301 22.2128 0.410156 21.9097V17.2988C0.412633 17.0146 0.522015 16.7411 0.717553 16.5303C1.98407 15.1924 3.52102 14.1247 5.23161 13.3944C6.94219 12.6641 8.78935 12.2871 10.6567 12.2871C12.5241 12.2871 14.3713 12.6641 16.0819 13.3944Z",
    fill: "#436D9F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6541 10.751C13.7013 10.751 16.1715 8.34253 16.1715 5.37158C16.1715 2.40062 13.7013 -0.0078125 10.6541 -0.0078125C7.60694 -0.0078125 5.13672 2.40062 5.13672 5.37158C5.13672 8.34253 7.60694 10.751 10.6541 10.751Z",
    fill: "#436D9F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAvatarChat);
export default __webpack_public_path__ + "static/media/IconAvatarChat.baae5ea58f60cf06e246cf9a925958d6.svg";
export { ForwardRef as ReactComponent };